import React, { PureComponent } from "react";
import SvgIcon from "material-ui/SvgIcon";

class ActiveList extends PureComponent {
    render() {
        return (
            <SvgIcon {...this.props}>
                <path
                    d="M24,14.3c-0.1-0.2-0.2-0.3-0.4-0.3l-5-0.1l-1.6-4.6C16.9,9.1,16.7,9,16.5,9s-0.4,0.1-0.4,0.3l-1.6,4.6l-5,0.1
                    c-0.2,0-0.4,0.1-0.4,0.3c-0.1,0.2,0,0.4,0.2,0.5l4,2.9l-1.4,4.6c-0.1,0.2,0,0.4,0.2,0.5C12,23,12.1,23,12.2,23s0.2,0,0.2-0.1
                    l4.1-2.8l4.1,2.8c0,0.1,0.1,0.1,0.2,0.1c0.1,0,0.2,0,0.2-0.1c0.1-0.1,0.2-0.3,0.2-0.5l-1.4-4.6l4-2.9C24,14.7,24,14.5,24,14.3z"
                />
                <path
                    d="M7.1,13.7c0.3-1,1.3-1.7,2.3-1.7l3.6-0.1l0.4-1.2H9.9C9.4,10.7,9,10.3,9,9.8V8.9C9,8.4,9.4,8,9.9,8h4.6c0.5-0.6,1.2-1,2-1
                    c0.8,0,1.5,0.4,2,1h0.3c0.5,0,0.9,0.4,0.9,0.9v0.9c0,0.2-0.1,0.5-0.3,0.6l0.5,1.5l2.4,0.1V1.8c0-1-0.8-1.8-1.8-1.8H2.8
                    C1.8,0,1,0.8,1,1.8v20.4c0,1,0.8,1.8,1.8,1.8h7.4c-0.5-0.6-0.6-1.4-0.4-2.2l0.2-0.5H9.9c-0.5,0-0.9-0.4-0.9-0.9v-0.9
                    c0-0.5,0.4-0.9,0.9-0.9h0.9l0-0.1L8,16.5C7.2,15.8,6.8,14.7,7.1,13.7z M9,3.6c0-0.5,0.4-0.9,0.9-0.9h8.9c0.5,0,0.9,0.4,0.9,0.9v0.8
                    c0,0.5-0.4,0.9-0.9,0.9H9.9C9.4,5.3,9,4.9,9,4.4V3.6z M6.4,20.4c0,0.5-0.4,0.9-0.9,0.9H4.6c-0.5,0-0.9-0.4-0.9-0.9v-0.9
                    c0-0.5,0.4-0.9,0.9-0.9h0.9c0.5,0,0.9,0.4,0.9,0.9V20.4z M6.4,15.1C6.4,15.6,6,16,5.5,16H4.6c-0.5,0-0.9-0.4-0.9-0.9v-0.9
                    c0-0.5,0.4-0.9,0.9-0.9h0.9c0.5,0,0.9,0.4,0.9,0.9V15.1z M6.4,9.8c0,0.5-0.4,0.9-0.9,0.9H4.6c-0.5,0-0.9-0.4-0.9-0.9V8.9
                    C3.7,8.4,4.1,8,4.6,8h0.9C6,8,6.4,8.4,6.4,8.9V9.8z M6.4,4.4c0,0.5-0.4,0.9-0.9,0.9H4.6c-0.5,0-0.9-0.4-0.9-0.9V3.6
                    c0-0.5,0.4-0.9,0.9-0.9h0.9c0.5,0,0.9,0.4,0.9,0.9V4.4z"
                />
                <polygon points="14.4,24 18.7,24 16.6,22.5  " />
            </SvgIcon>
        );
    }
}

export default ActiveList;
